import {Component, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ExpertPaymentService} from '@services/expert-payment.service';
import {NotificationService} from '@services/frontend/notification.service';

@Component({
  selector: 'app-expert-payment',
  templateUrl: './expert-payment.html',
})
export class ExpertPayment implements OnInit {
  private readonly expertPaymentService = inject(ExpertPaymentService);
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  loading = signal(false);
  checkingStatus = signal(true);

  ngOnInit(): void {
    const checkout = this.route.snapshot.queryParamMap.get('checkout');
    if (checkout === 'success') {
      this.notificationService.success('Paiement reçu. Activation de votre accès…', 4000);
    } else if (checkout === 'cancel') {
      this.notificationService.error('Paiement annulé', 3000);
    }
    this.verifyPaymentAndRedirect();
  }

  startPayment(): void {
    this.loading.set(true);
    this.expertPaymentService.createExpertPaymentCheckout().subscribe({
      next: (res) => {
        this.loading.set(false);
        if (res.url) {
          window.location.href = res.url;
        }
      },
      error: () => {
        this.loading.set(false);
        this.notificationService.error('Impossible d\'ouvrir le lien de paiement', 3000);
      },
    });
  }

  private verifyPaymentAndRedirect(): void {
    this.checkingStatus.set(true);
    this.expertPaymentService.checkExpertPayment().subscribe({
      next: (status) => {
        this.checkingStatus.set(false);
        if (status.paid) {
          void this.router.navigate(['/dashboard', 'expert', 'clients']);
        }
      },
      error: () => this.checkingStatus.set(false),
    });
  }
}
